import { useMobileShellRegistrar } from "@/react/components/Mobile/hooks/useMobileShellRegistrar";
import { MobileFullBleedContentRegistrar } from "@/react/components/Mobile/shell/chrome/MobileFullBleedContentRegistrar";

/**
 * Removes `MobileShell.Content`'s default horizontal padding for the
 * lifetime of the calling component, letting the page's own content span
 * the full viewport width edge-to-edge.
 *
 * Usage:
 * ```tsx
 * const MyFullBleedPage = () => {
 *   const fullBleedContent = useMobileFullBleedContent();
 *   return (
 *     <>
 *       {fullBleedContent}
 *       <div>...page content that controls its own padding...</div>
 *     </>
 *   );
 * };
 * ```
 */
export const useMobileFullBleedContent = ({
  enabled = true,
}: { enabled?: boolean } = {}) =>
  useMobileShellRegistrar(MobileFullBleedContentRegistrar, enabled ? {} : null);
